import React, { createContext, useContext, useReducer, ReactNode } from 'react';

export type SessionStatus = 'IDLE' | 'CONNECTING' | 'CONNECTED' | 'DISCONNECTED' | 'ERROR';

interface SessionState {
  status: SessionStatus;
  error: string | null;
}

type Action = 
  | { type: 'CONNECTING' }
  | { type: 'CONNECTED' }
  | { type: 'DISCONNECTED' }
  | { type: 'ERROR'; payload: string };

const initialState: SessionState = { status: 'IDLE', error: null };

function sessionReducer(state: SessionState, action: Action): SessionState {
  switch (action.type) {
    case 'CONNECTING': return { status: 'CONNECTING', error: null };
    case 'CONNECTED': return { status: 'CONNECTED', error: null };
    case 'DISCONNECTED': return { status: 'DISCONNECTED', error: null };
    case 'ERROR': return { status: 'ERROR', error: action.payload };
    default: return state;
  }
}

const SessionContext = createContext<{ state: SessionState; dispatch: React.Dispatch<Action> } | undefined>(undefined);

export const SessionProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(sessionReducer, initialState);
  return <SessionContext.Provider value={{ state, dispatch }}>{children}</SessionContext.Provider>;
};

export const useSessionState = () => {
  const context = useContext(SessionContext);
  if (!context) throw new Error('useSessionState must be used within SessionProvider');
  return context;
};
